enum GatewayContainerConstants {
  GET_GATEWAYS = '@GatewaysContainer/GET_GATEWAYS',
  GET_GATEWAYS_REQUEST = '@GatewaysContainer/GET_GATEWAYS_REQUEST',
  GET_GATEWAYS_REQUEST_SUCCESS = '@GatewaysContainer/GET_GATEWAYS_REQUEST_SUCCESS',
  GET_GATEWAYS_REQUEST_ERROR = '@GatewaysContainer/GET_GATEWAYS_REQUEST_ERROR',

  REMOVE_GATEWAY = '@GatewaysContainer/REMOVE_GATEWAY',
  REMOVE_GATEWAY_REQUEST = '@GatewaysContainer/REMOVE_GATEWAY_REQUEST',
  REMOVE_GATEWAY_REQUEST_SUCCESS = '@GatewaysContainer/REMOVE_GATEWAY_REQUEST_SUCCESS',
  REMOVE_GATEWAY_REQUEST_ERROR = '@GatewaysContainer/REMOVE_GATEWAY_REQUEST_ERROR',

  RESET_GATEWAY_ERROR = '@GatewaysContainer/RESET_GATEWAY_ERROR',
}

export default GatewayContainerConstants;
